// TODO: REFACTORING
import React from 'react';

const PlaceholderImageLoading = () => {
  return <div>{/* <das */}</div>;
};
export default PlaceholderImageLoading;
